import React from 'react'
import { Form, Input } from 'antd'

export const TextAreaComments = ({ nameInput = [], isRequired = false, disabled = false, placeholder = "" }) => {
    return (
        <Form.Item
            name={nameInput}
            className="w-full mb-0"
            rules={[
                {
                    required: isRequired,
                    message: "Necesita al menos un comentario",
                },
            ]}
        >
            <Input.TextArea
                disabled={disabled}
                className='text-[10px] md:text-[12px] text-[#686868]'
                placeholder={placeholder}
                autoSize={{
                    minRows: 5,
                    maxRows: 5,
                }}
                showCount={false}
            />
        </Form.Item>
    )
}
